{
    "filter_header__title": "Verwendete Filter",
    "filter_header__title_short": "Filter",
    "filter_header__filter_button": "Filtern",
    "filter_header__delete_button": "Löschen",
    "filter_header__delete_all_button": "Alle Löschen"
}
